import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../../api';


export default function GeneralLedger() {
  const [accounts, setAccounts] = useState([]);
  const [accountId, setAccountId] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [report, setReport] = useState(null);

  useEffect(() => {
    api(`/accounts`).then(r => r.json()).then(setAccounts).catch(() => {});
  }, []);

  const runReport = async () => {
    if (!accountId) return;
    const params = new URLSearchParams({ accountId });
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    const res = await api(`/reports/general-ledger?${params}`);
    if (res.ok) setReport(await res.json());
  };

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow mb-6">
        <div className="p-4 md:p-6 border-b">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">General Ledger</h1>
          <div className="flex flex-col sm:flex-row gap-4 items-end">
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">Account *</label>
              <select value={accountId} onChange={(e) => setAccountId(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-600">
                <option value="">Select account</option>
                {accounts.map(a => <option key={a.id} value={a.id}>{a.code} — {a.name}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">From</label>
              <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-600" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">To</label>
              <input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-600" />
            </div>
            <button onClick={runReport} disabled={!accountId} className="px-6 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 disabled:opacity-50">Run</button>
          </div>
        </div>
      </div>

      {report && (
        <div className="bg-white rounded-lg shadow">
          <div className="p-4 md:p-6 border-b">
            <h2 className="text-xl font-semibold text-gray-900">{report.accountCode} — {report.accountName}</h2>
            <p className="text-sm text-gray-500">{report.accountType}</p>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Reference</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Description</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Debit</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Credit</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Balance</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {(report.entries || []).map((e, i) => (
                  <tr key={i}>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-900">{e.entryDate}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-600 hidden md:table-cell">{e.reference || '—'}</td>
                    <td className="px-6 py-4 text-gray-600 hidden md:table-cell">{e.description || '—'}</td>
                    <td className="px-6 py-4 text-right font-mono">{e.debit > 0 ? e.debit.toFixed(2) : ''}</td>
                    <td className="px-6 py-4 text-right font-mono">{e.credit > 0 ? e.credit.toFixed(2) : ''}</td>
                    <td className="px-6 py-4 text-right font-mono font-semibold">{e.balance.toFixed(2)}</td>
                  </tr>
                ))}
                <tr className="bg-gray-50 font-semibold">
                  <td colSpan={3} className="px-6 py-3 text-right">Totals</td>
                  <td className="px-6 py-3 text-right font-mono">{(report.totalDebit || 0).toFixed(2)}</td>
                  <td className="px-6 py-3 text-right font-mono">{(report.totalCredit || 0).toFixed(2)}</td>
                  <td className="px-6 py-3 text-right font-mono">{(report.endingBalance || 0).toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          {(report.entries || []).length === 0 && <div className="text-center py-12 text-gray-500">No posted entries for this account.</div>}
        </div>
      )}
    </Layout>
  );
}
